<template>
  <image-container-card
    :as="as"
    :image="card.imageCustom || card.image"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <div class="showcase-card-info">
      <div class="card-set">{{ card.year }} {{ card.set }}</div>

      <div class="card-name">
        {{ card.player }}<span v-if="card.number"> #{{ card.number }}</span>
      </div>

      <div v-if="card.variation" class="card-detail">
        {{ card.variation }}
      </div>

      <div v-if="gradeLabel" class="card-detail card-grade">
        {{ gradeLabel }}
      </div>

      <div v-if="$slots.default" class="owner">
        <slot />
      </div>
    </div>
  </image-container-card>
</template>

<script>
import { getConditionDisplay } from '../utils/format.util';

import ImageContainerCard from './ImageContainerCard';

export default {
  components: {
    ImageContainerCard,
  },

  props: {
    as: String,
    card: Object,
  },

  computed: {
    gradeLabel() {
      if (this.card.grader && this.card.grade && !this.card.cardId) {
        return getConditionDisplay(
          this.card.grader,
          this.card.grade,
          this.card.autographGrade,
          this.card.qualifierType,
        );
      }

      return [this.card.condition, this.card.qualifierType].filter(Boolean).join(' ');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.showcase-card-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.card-set,
.card-name {
  @include ellipsis;
}

.card-set {
  line-height: 1.3;
  height: 1.3em;
}

.card-name {
  margin: 2px 0 $gp * .4;
  font-size: 17px;
  font-weight: bold;
  line-height: 1.25;
  height: 1.25em;
}

.card-detail {
  overflow-wrap: break-word;
  font-size: 14px;
  line-height: 1.35;

  + .card-detail {
    margin-top: $gp * .15;
  }
}

.card-grade {
  font-weight: 700;
}

.owner {
  margin-top: auto;
  padding-top: $gp * .75;
}
</style>
